import React from 'react';

import type { GuestAccessRuleDto } from '../api/guestAccessTypes';
import { isRuleFinished } from '../domain/guestAccess/guestAccess';
import { guestAccessService } from '../services/singletons';
import { useAppSelector } from '../store/hooks';

/**
 * Open and upcoming guest access rules, for every signed-in user. Failures are swallowed: the feature only
 * decorates the UI, and the server enforces access anyway.
 */
export function useActiveGuestAccess() {
  const isSignedIn = useAppSelector((s) => s.auth.user != null);
  const [rules, setRules] = React.useState<GuestAccessRuleDto[]>([]);
  const [loaded, setLoaded] = React.useState(false);

  const reload = React.useCallback(async () => {
    try {
      const list = await guestAccessService.listActiveRules();
      setRules(list.filter((rule) => !isRuleFinished(rule)));
    } catch {
      setRules([]);
    } finally {
      setLoaded(true);
    }
  }, []);

  React.useEffect(() => {
    if (isSignedIn) void reload();
  }, [isSignedIn, reload]);

  return { rules, loaded, reload };
}
